export default {
  mapRightClick: {
    options: 'Options',
    addDestinationToRoute: 'Append as destination',
    directionsFromHere: 'Directions from here',
    directionsToHere: 'Directions to here',
    nonStopDirectionsToHere: 'Direct to here',
    addRouteStop: 'Add stop here',
    centerHere: 'Center here',
    addAsIsochroneCenter: 'Add as reach center',
    inspectDataOnOSM: 'Inspect data on OSM'
  }
}
